<template>
  <div class="products-input-base" :style="styles">
    <block-title :target-info="counselorInfos.information" :color-scheme="counselorInfos.colorScheme" />
    <block-fortune-input
      :token="csrfToken"
      :target-info="counselorInfos.information"
      :color-scheme="counselorInfos.colorScheme"
      :action="targetAction"
      button-label="占う"
      method="post"
    />
    <recommend-block-plus
      :recommend-data="standardRecommendData"
      :color-scheme="recommendColorScheme"
    />
  </div>
</template>

<script>
import {BASIC_DATA, DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import {INPUT_PARAMS} from '@/utvStore/components/Products/inputParams'
import moment from 'moment'
import * as type from '@/utvStore/store/mutation-types'
import BlockFortuneInput from '../partials/BlockFortuneInput'
import BlockTitle from '@/utvStore/components/recommend/lp/blocks/BlockTitle'
import RecommendBlockPlus from '@/utvStore/components/common/RecommendBlockPlus'

export default {
  name: 'ProductsInput01',
  components: {
    BlockTitle,
    RecommendBlockPlus,
    BlockFortuneInput,
  },
  props: {
    requireProf: {
      type: Array,
      default: null,
    },
    standardRecommendData: {
      type: Array,
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
  },
  data(){
    return {
      lock: false,
      textareaValue: '',
    }
  },
  computed: {
    targetAction(){
      return '/products/44/0001/result'
    },
    counselorInfos(){
      console.log('mone%O', {
        ...BASIC_DATA.somarimone,
        information: {
          title: {
            subTitle: 'そまり百音のねこ風水',
            title: '3年の運気の流れ',
          },
        }
      })
      return {
        ...BASIC_DATA.somarimone,
        information: {
          title: {
            subTitle: 'そまり百音のねこ風水',
            title: '3年の運気の流れ',
          },
        }
      }
    },
    recommendColorScheme() {
      return {
        keyColor: this.counselorInfos.colorScheme.keyColor,
      }
    },
    styles(){
      return {
        '--key-color': this.counselorInfos.colorScheme.keyColor,
        '--mess-bg': this.counselorInfos.colorScheme.messBg,
      }
    },
  },
  created() {
    this.$store.dispatch(type.SET_COLOR_SCHEME, this.counselorInfos.colorScheme)
  },
  mounted() {
  },
  methods: {
    onSubmitClick(){
      if(!this.lock){
        this.lock = true
        this.$refs.tgtform.submit()
      }
    }
  },
}</script>

<style scoped lang='scss'>
@import "../../../../../../sass/commons/commonVariables.scss";
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/somarimone/fortunes/ProductsInput01.vue